export enum QuestsType {
	AnyCategory = 0,
	UncoveredClaims = 1,
	PotentialDiscontinuation = 2,
	UnmatchedRecords = 3,
}
